import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import { Box } from '@ch/common/components/box';
import { Content } from '@ch/common/components/content';

const QuizFieldHints: FC<{ hints: string[] }> = ({ hints = [] }) =>
  hints?.length > 0 && (
    <Box $m={[8, 0, 0]}>
      {hints.map((hint, index) => (
        <Content key={`${index}`} $size="sm" $color="primary" $m={[0]}>
          <ReactMarkdown>{hint}</ReactMarkdown>
        </Content>
      ))}
    </Box>
  );

export default QuizFieldHints;
